import React from 'react';

import LanguagePicker from 'components/nav/shared/LanguagePickerContainer';
import NavLink from 'components/nav/shared/NavLink';

class UtilityItems extends React.Component {
  render() {
    return (
      <ul className="nav navbar-nav">
        <li><LanguagePicker className="hidden-xs" /></li>
        <li><NavLink to="/help" type="Link" stringID="AA_Help" /></li>
      </ul>
    );
  }
}

export default UtilityItems;
